import React from 'react'
import { PageHeader } from '../components'

const PrivacyPolicyPage = () => (
  <div className="page">
    <PageHeader title="Privacy policy" />
    <div className="privacy-policy-content">
		<p>Your privacy is important to us. It is Milan Kriško's policy to respect your privacy regarding any information we may collect from you across our website, <a href="https://vobo.io/">https://vobo.io/</a>, and other sites we own and operate.</p>
		<p>We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.</p>
		<p>We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.</p>
		<p>We don’t share any personally identifying information publicly or with third-parties, except when required to by law.</p>
		<p>Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.</p>
		<p>You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.</p>
		<p>Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.</p>
		<p>This policy is effective as of 19 February 2019.</p>
		{/*
			<p>
				This Privacy Policy explains how we and some of the companies we work with
				collect, use, share and protect information in relation to our web site.
			</p>
			<p>
		    By using our Service you understand and agree that we are providing a
		    platform for you to process your content.
			</p>
			<p>
		    Our Policy applies to all visitors, users, and others who access the
		    Service (“Users”).
			</p>
			<p>
			  <strong>1. INFORMATION WE COLLECT</strong>
			</p>
			<p>
		    We collect the following types of information.
			</p>
			<p>
		    Information you provide us directly:
			</p>
			<p>
		    User Content (e.g., lessons, tests, classes and other materials) that you post
		    through the Service. Communications between you and Mailchimp. For example,
		    we may send you Service-related emails (e.g., changes/updates to features
		    of the Service). You may not opt out of Service-related e-mails.
			</p>
			<p>
		    Analytics information:
			</p>
			<p>
		    We use third-party analytics tools to help us measure traffic and usage
		    trends for the Service. We collect and use
		    this analytics information with analytics information from other Users so
		    that it cannot reasonably be used to identify any particular individual
		    User.
			</p>
			<p>
		    Cookies and similar technologies:
			</p>
			<p>
		    When you visit the Service, we may use cookies and similar technologies
		    like pixels, web beacons, and local storage to collect information about
		    how you use Service and provide features to you.
			</p>
			<p>
			    <strong>2. HOW WE USE YOUR INFORMATION</strong>
			</p>
			<p>
			    In addition to some of the specific uses of information we describe in this
			    Privacy Policy, we may use information that we receive to:
			</p>
			<ul>
			    <li>
			        <p>
			            provide personalized content and information to you and others,
			            which could include online ads or other forms of marketing
			        </p>
			    </li>
			    <li>
			        <p>
			            provide, improve, test, and monitor the effectiveness of our
			            Service
			        </p>
			    </li>
			    <li>
			        <p>
			            develop and test new products and features
			        </p>
			    </li>
			    <li>
			        <p>
			            monitor metrics such as total number of visitors, traffic, and
			            demographic patterns
			        </p>
			    </li>
			    <li>
			        <p>
			            diagnose or fix technology problems
			        </p>
			    </li>
			</ul>
			<p>
			    <strong>3. SHARING OF YOUR INFORMATION</strong>
			</p>
			<p>
			    We will not rent or sell your information to third parties outside Service
			    (or the group of companies of which Service is a part) without your
			    consent.
			</p>
			<p>
			    We may also combine your information with other information in a way that
			    it is no longer associated with you and share that aggregated information.
			</p>
			<p>
			    <strong>4. HOW WE STORE YOUR INFORMATION</strong>
			</p>
			<p>
			    Storage and Processing:
			</p>
			<p>
			    Your information collected through the Service may be stored and processed
			    in the Czech Republic or any other country in which Service, its Affiliates
			    or Service Providers maintain facilities.
			</p>
			<p>
			    Service, its Affiliates, or Service Providers may transfer information that
			    we collect about you, including personal information across borders and
			    from your country or jurisdiction to other countries or jurisdictions
			    around the world. If you are located in the European Union, U.S. or other
			    regions with laws governing data collection, please note that we may
			    transfer information, including personal information, to a country and
			    jurisdiction that does not have the same data protection laws as your
			    jurisdiction.
			</p>
			<p>
        <strong>5. HOW TO CONTACT US</strong>
			</p>
			<p>
			    If you have any questions about this Privacy Policy or the Service, please
			    contact us through the email <a href="mailto:support@vobo.io">support@vobo.io</a>.
			</p>
			<p>
			    <strong>6. CHANGES TO OUR PRIVACY POLICY</strong>
			</p>
			<p>
			    Service may modify or update this Privacy Policy from time to time, so
			    please review it periodically. We may provide you additional forms of
			    notice of modifications or updates as appropriate under the circumstances.
			    Your continued use of the Service after any modification to this Privacy
			    Policy will constitute your acceptance of such modification.
			</p>
	      <p>
			    Updated: August 30, 2018
			</p>
	*/}
	<h3>Information we collect from other sources</h3>
	<p>
		We also collect some information from other sources and combine that with information we collect from you. We do not control, supervise or respond for how the third parties providing your information process your personal data, and any information request regarding the disclosure of your personal information to us should be directed to such third parties.
	</p>
	<p>
		The information we collect about you from third parties includes:
	</p>
	<p>
		Facebook Connect and Google Login
		You have the option to log in to our site using sign-in services such as Facebook Connect and Google Login. These services authenticate your identity and provide you the option to share certain personal information with us, such as your name, date of birth, and email address, to pre-populate our sign-up form. You may, optionally, choose to provide additional information during the sign-up or linking process, such as a friends list, to enable certain features on Vobo.io.
	</p>

	<h3>Advertising, Analytics and Marketing</h3>
	<p>
In order to support the Vobo.io and provide our users with relevant information regarding the Service and opportunities presented by partners, Vobo.io may use your personal information for the purposes of:
</p>
<p>
Marketing the Service.
Communicating with you and others about opportunities, products, services, contests, promotions, discounts, incentives, surveys, and rewards offered by us and select partners.
Displaying relevant advertising to you while using the Service.
While we expect marketing and promotional material will not be voluminous, you may choose to object to this use of your data at any time and opt-out of receiving future offers or marketing material.
</p>
<p>
This Privacy Notice does not apply to, and we are not responsible for, third-party cookies, web beacons, or other tracking technologies, which are covered by such third parties’ privacy policies. For more information, we encourage you to check the privacy policies of these third parties to learn about their privacy practices. For more information about targeted advertising specifically, please visit this site.
</p>
<p>
Promotional Communications
You may receive promotional messages from Vobo.io when you first interact with the Service or by making a request to us. You can opt out of receiving promotional messages from Vobo.io at the time we collect your information by following the instructions on screen, in those messages, or by changing your notification settings in your Vobo.io account. Opting out of receiving communications may impact your use of the Services. If you decide to opt out, we can still send you non-promotional communications, such as digital receipts and messages about your account or our ongoing business relations.
</p>
<p>
Third-Party Analytics
We can use third-party service providers to provide site metrics and other analytics services. These third parties can use technologies discussed below, such as cookies, web beacons, and other technologies, to collect information, such as your IP address, identifiers associated with your device, other applications on your device, the browsers you use to access the Service, the pages viewed, how much time you spend on a page or Vobo.io overall, links you clicked, and activity information (for example, study sessions you have completed). This information can be used by Vobo.io and third-party service providers on behalf of Vobo.io to analyse and track usage of the Service, determine the popularity of certain content, and better understand how you use the Service. The third-party service providers that we engage are bound by confidentiality obligations and other restrictions with respect to their collection, use and disclosure of your information.
</p>
<p>
Advertising on Vobo.io
</p>
<p>
Vobo.io and our third-party advertising partners may serve advertisements when you visit our website. In order to provide advertisements about goods and services of interest to you, Vobo.io and our third-party advertising partners may use information collected from you, or from devices associated with you (not including your name, address, email address or telephone number), and your visits to this and other websites to show you more relevant ads. If you would like more information about this practice and to know your choices about not having this information used by these companies, click here.

	</p>

	<h3>General Data Protection Regulation (GDPR)</h3>
	<p>
	Vobo.io processes your personal data only when we have a lawful basis for doing so. For example, some of the information we collect from you we need to enable use to deliver the Services to you and fulfill our agreement under the Terms of Service, sometimes we collect and process your data when you have given us consent to do so, sometimes we are required by law and regulations to collect and process this information about you, and, at other times, we consider it to be in our legitimate interest to collect and process this information, taking into consideration your privacy rights. In rare cases we also may be required to process your data to protect your vital interests or for a task in the public good.
	</p>
	<p>
	European users also have several rights under the General Data Protection Regulation in certain circumstances, including the right to access, update and remove your personal data, object to particular processing, or file a complaint with our privacy team or a supervisory authority. You can find out more about Vobo.io’s approach to the GDPR, including how to exercise these rights, here. Note we may need to verify your identity before granting access or otherwise changing or correcting your information.
	</p>
	<p>
	Data Protection Officer Contact Information<br />
	Milan Kriško<br />
	Attention: Data Protection Officer<br />
	Priechod 119<br />
	97611 Selce, Slovakia
	</p>
	<p>
	support@vobo.io<br />
	+420607043673
	</p>
	</div>
  </div>
)

export default PrivacyPolicyPage



// WEBPACK FOOTER //
// ./src/browser/pages/PrivacyPolicyPage.js